// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29nCT","newExpiryDate":"styles_newExpiryDate__3yAOg","footer":"styles_footer__357TH"};